export const TypeAngles = {
    "Tipo 1": 0,
    "Tipo 2": 30,
    "Tipo 3": 70,
    "Tipo 4": 110,
    "201": 0,
    "202": 30,
    "203": 70,
    "204": 110,
}